import { removeEmpty } from '../helpers/helper';
import { SnowplowHelper } from '../helpers/snowplow_helper';

import { loadUtag, utag } from './tealium_helper';
import WrappedProvider from './wrapped_provider';

// Underscore session, user, and visitor ids
const formatIds = ({ sessionId, userId, visitorId, ...obj }: any) => ({
  ...obj,
  ...removeEmpty({ session_id: sessionId, user_id: userId, visitor_id: visitorId }),
});

function tealiumUtag(name: any, props: any, utagMethod = 'link') {
  utag(utagMethod, [
    formatIds({
      tealium_event: name,
      ...props,
    }),
  ]);
}

class TealiumProvider extends WrappedProvider {
  static configKey = 'tealium';
  static isApprovedProvider = false;
  static providerName = 'Tealium';

  load(_snowplowHelper: SnowplowHelper | null = null) {
    loadUtag(this.config.accountProfileEnv);
  }

  group({ data, ...props }: any) {
    tealiumUtag('Group', { ...data, ...props });
  }

  identify({ data, ...props }: any) {
    tealiumUtag('Identify', { ...data, ...props });
  }

  page({ data, pageName = '', ...props }: any) {
    tealiumUtag(
      'Viewed Page',
      {
        page_name: pageName,
        ...data,
        ...props,
      },
      'view',
    );
  }

  track({ data, eventCategory, eventName, ...props }: any) {
    tealiumUtag(`${eventCategory}${eventName}`, {
      event_category: eventCategory,
      event_name: eventName,
      ...data,
      ...props,
    });
  }
}

export default TealiumProvider;
